module.exports = __webpack_public_path__ + "img/facebook.af3252b6.png";